import { useEffect, useMemo, useState } from 'react';
import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';
import { isMobile, isTablet } from 'react-device-detect';
import { useCurrentWebPageConfig } from '../../hooks/useCurrentWebPageConfig';

export const useShowTopGap = () => {
    const TelegramWebApp = getTelegramWebApp();

    const [isFullscreen, setIsFullScreen] = useState(TelegramWebApp?.isFullscreen === true);

    const { currentPageConfig } = useCurrentWebPageConfig();
    const currentPageOptions = currentPageConfig?.optionsWeb;

    useEffect(() => {
        if (!TelegramWebApp) return undefined;

        const updateFullScreenStatus = () => {
            const isFullscreenNow = TelegramWebApp?.isFullscreen === true;
            setIsFullScreen(isFullscreenNow);
        };

        if (typeof TelegramWebApp.onEvent === 'function') {
            TelegramWebApp.onEvent('fullscreenChanged', updateFullScreenStatus);
        }

        return () => {
            if (typeof TelegramWebApp.offEvent === 'function') {
                TelegramWebApp.offEvent('fullscreenChanged', updateFullScreenStatus);
            }
        };
    }, [TelegramWebApp]);

    return useMemo(() => {
        if (currentPageOptions?.topGap?.showTopGap) return true;
        if (!isFullscreen) return false;
        if (isMobile || isTablet) return true;

        return false;
    }, [currentPageOptions?.topGap?.showTopGap, isFullscreen]);
};
